<!--
 * @Author: M.D.
 * @Date: 2019-12-23 16:12:50
 * @LastEditors  : M.D.
 * @Description: 个人中心、我的订单  订单列表组件
 * @Remarks:
 -->
<template>
  <ul class="ui-goods-list">
    <div v-show="orderNone" class="order-none">
      <img src="@/assets/image/order_none.png" alt="" />
      <p>暂无订单</p>
      <p />
    </div>
    <li
      class="uc-item"
      @click="goOrderDetail(item)"
      v-for="(item, index) in orderList"
      :key="index"
    >
      <div class="uc-img-sec bShadow-10">
        <div class="uc-goods-w">
          <img
            :src="tImgUrl(item.image.split(',')[0])"
            alt=""
            :onerror="errImgDefault"
          />
        </div>
      </div>
      <div class="uc-info">
        <div class="p-name">{{ item.goodsName }}</div>
        <div class="sub-name">{{ item.intro || '' }}</div>
      </div>
      <div class="price">
        <span class="uc-p-num priceclass">{{ priceDis(item) }}</span>
      </div>
      <div class="status">
        <div class="status-wrapper">
          <div class="main-txt">{{ getStatusText(item.status) }}</div>
          <div class="uc-sub-txt" v-if="item.deadline && item.deadline.length">
            <span :id="item.id" class="time">{{ opTimeCounter(item) }}</span>
          </div>
        </div>
      </div>
      <div class="handler">
        <div class="handler-wrapper">
          <el-button
            type="success"
            size="medium"
            @click.stop="goToPayPage(item)"
            round
            v-if="item.status === 0"
            >立即付款
          </el-button>
          <el-button
            type="text"
            class="text-button"
            size="medium"
            @click.stop="cancelOrder(item)"
            round
            v-if="item.status === 0 || item.status === 4"
            >取消订单
          </el-button>
          <el-button
            type="success"
            size="medium"
            @click.stop="goToEvaluate(item)"
            round
            v-if="item.status === 6"
            >评价
          </el-button>
          <el-button
            type="success"
            size="medium"
            @click.stop="deliveryGoods(item)"
            round
            v-if="item.status === 8"
            >确认收货
          </el-button>
          <el-button
            type="success"
            size="medium"
            round
            @click.stop="createInvoice(item)"
            v-if="
              ivShow(item) &&
              item.type !== 3 &&
              item.isApplyInvoice === 1 &&
              (item.status === 3 || item.status === 1 || item.status === 6)
            "
          >
            补开发票
          </el-button>
          <el-button
            type="text"
            class="text-button"
            size="medium"
            round
            @click.stop="goInvoiceDetailPage(item)"
            v-if="
              item.isApplyInvoice === 0 &&
              (item.status === 1 ||
                item.status === 3 ||
                item.status === 6 ||
                item.status === 7 ||
                item.status === 8)
            "
          >
            查看发票
          </el-button>
          <el-button
            type="text"
            size="medium"
            round
            disabled
            v-if="item.isApplyInvoice === 2"
          >
            发票开具中
          </el-button>
          <el-button
            class="text-button"
            :type="'text'"
            size="medium"
            round
            @click.stop="queryQrCode(item)"
            v-if="item.status === 1 && item.isOnTrain === 2"
          >
            查看二维码
          </el-button>
        </div>
      </div>
    </li>
    <invoice-info
      :show="showInvoice"
      :orderId="this.currentOrderId"
      @visibleUpdate="visibleUpdate"
    ></invoice-info>
    <od-qrcode-dialog
      :selectedOrder="selectedOrder"
      :show="qrDialogShow"
      @qrcodeDialogClose="qrcodeDialogClose"
    />
  </ul>
</template>

<script>
import InvoiceInfo from '@/components/invoice-info'
import OdQrcodeDialog from '@/components/od-qrcode-dialog'
import API from '@/api/ord-api'

export default {
  props: {
    orderList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      deadlineDate: undefined,
      selectedOrder: {},
      currentOrderId: '',
      qrDialogShow: false,
      showInvoice: false,
      // 0待支付 1已支付 2支付中 3已完成 4待确认 -1已退款 5取消 6 待评价 7待发货 8已货
      statusMap: {
        0: '待支付',
        1: '已支付',
        2: '支付中',
        3: '已完成',
        4: '待确认',
        '-1': '已退款',
        5: '已取消',
        6: '待评价',
        7: '待发货',
        8: '已发货',
        9: '支付超时关闭',
        1001: '操作超时',
      },
    }
  },
  computed: {
    orderNone() {
      return !`${this.orderList}`
    },
  },
  created() {},
  mounted() {},
  activated() {},
  deactivated() {},
  watch: {},
  methods: {
    opTimeCounter(item) {
      // console.log(item.id)
      if (!item) {
        return
      }
      if (item.deadline) {
        var curTime = new Date(item.createTime)
        console.log(curTime)
        var addMinute = new Date(curTime.setMinutes(curTime.getMinutes() + 15))
        var y = addMinute.getFullYear()
        var m =
          addMinute.getMonth() + 1 < 10
            ? '0' + (addMinute.getMonth() + 1)
            : addMinute.getMonth() + 1
        var d = addMinute.getDate() < 10 ? '0' + addMinute.getDate() : addMinute.getDate()
        var h = addMinute.getHours() < 10 ? '0' + addMinute.getHours() : addMinute.getHours()
        var f =
          addMinute.getMinutes() < 10 ? '0' + addMinute.getMinutes() : addMinute.getMinutes()
        var s =
          addMinute.getSeconds() < 10 ? '0' + addMinute.getseconds() : addMinute.getSeconds()
        var formatdate = y + '/' + m + '/' + d + ' ' + h + ':' + f + ':' + s
        item.deadline = formatdate
      }

      const vm = this
      this.timeCounter(
        item,
        function () {
          vm.$emit('orderUpdate')
        },
        () => {
          item.status = '1001'
          item.isApplyInvoice = -1
        },
      )
    },
    ivShow(item) {
      return this.priceDis(item) !== '￥0.00'
    },
    async deliveryGoodsAPI(i) {
      const res = await API.cancelOrder({ orderId: i.id, status: 3 })
      if (res.data.statusCode === '200') {
        // window.location.reload()
        this.$emit('orderUpdate')
      }
      this.$message({
        type: 'success',
        message: res.data.result,
      })
    },
    async handleCancelOrder(i) {
      const res = await API.cancelOrder({ orderId: i.id, status: 5 })
      if (res.data.statusCode === '200') {
        // window.location.reload()
        this.$emit('orderUpdate')
      }
      this.$message({
        type: 'success',
        message: res.data.result,
      })
    },
    goOrderDetail(i) {
      // const url = window.location.origin
      // window.open(`${url}/orderDetail/${i.id}`)
      // this.$router.push({ path: `/orderDetail/${i.id}` })
      this.$router.push({
        name: 'orderDetail',
        params: {
          orderId: i.id,
          isOnTrain: i.isOnTrain,
        },
      })
    },
    getStatusText(status) {
      return this.statusMap[status]
    },
    goToEvaluate(i) {
      this.$router.push({ name: 'evaluate', query: { orderId: i.id } })
      // window.open(pag.href, '_blank')
    },
    deliveryGoods(i) {
      let _this = this
      this.$confirm('是否确认收货?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          _this.deliveryGoodsAPI(i)
        })
        .catch(() => {})
    },
    visibleUpdate(b) {
      this.showInvoice = b
      this.$emit('orderUpdate')
    },
    cancelOrder(i) {
      let _this = this
      this.$confirm('是否取消订单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          _this.handleCancelOrder(i)
        })
        .catch(() => {})
    },
    goToPayPage(i) {
      this.$router.push({
        name: 'payQRCode',
        query: { orderId: i.id, orderNumber: i.orderNumber },
      })
    },
    createInvoice(i) {
      this.currentOrderId = i.id
      this.showInvoice = true
    },
    goInvoiceDetailPage(i) {
      window.open(i.invoiceUrl)
    },
    queryQrCode(i) {
      this.selectedOrder = i
      this.qrDialogShow = true
      // setTimeout(() => {
      //   this.selectedOrder = i
      //   var canvas = document.getElementById('qrcode')
      //   QRCode.toCanvas(canvas, `http://kentrasoft.com/js-esp-mobile/#/sweep-code?orderNumber=${i.orderNumber}`, { width: 200 }, function (error) {
      //     if (error) console.error(error)
      //   })
      // }, 300)
    },
    qrcodeDialogClose(v) {
      this.qrDialogShow = v
    },
  },
  components: {
    InvoiceInfo,
    OdQrcodeDialog,
  },
}
</script>

<style lang="stylus" scoped>
.ui-goods-list {
  width: 100%;

  // margin-bottom 80px
  .order-none {
    width: 100%;
    text-align: center;
    padding-top: 100px;

    p {
      color: #dddddd;
    }
  }

  .uc-item {
    width: 100%;
    height: 100px;
    border-bottom: 1px solid #dddddd;
    box-sizing: border-box;
    padding: 12px;
    display: flex;

    &:last-child {
      border-bottom: none;
    }

    .uc-img-sec {
      flex: 0 0 120px;
      center();
      overflow: hidden;

      .uc-goods-w {
        goods-img-wrapper();

        img {
          goods-img-image();
        }
      }
    }

    .uc-info {
      width: 400px;
      flex: 0 0 250px;
      box-sizing: border-box;
      padding: 15px 10px;

      // background-color green
      .p-name {
        height: 20px;
        max-width: 230px;
        ellipsis2(2);
        line-height: 24px;
        font-size: 16px;
        color: #333333;
      }

      .sub-name {
        color: #999999;
        height: 25px;
        overflow: hidden;
        font-size: 12px;
        max-width: 230px;
        // ellipsis2(2)
        white-space: nowrap;
        text-overflow: ellipsis;
        leftBottom();
      }
    }

    .price {
      flex: 0 0 150px;
      // background-color yellow
      center();
      font-size: 18px;
    }

    .status {
      flex: 0 0 150px;
      position: relative;
      center();

      .main-txt {
        // height 100%
        height: auto;
        // color: orange-color;
        color: #ff7a00;
        text-align: center;
      }

      // .main-txt-1
      // height auto
      // font-size 12px
      // line-height 50px
      // color: rgba(153,153,153,1)
      .uc-sub-txt {
        margin-top: 10px;
        text-align: center;
        width: 100%;
        color: #999999;
        font-size: 12px;
      }
    }

    .handler {
      flex: 1 1 auto;

      .handler-wrapper {
        height: 100%;
        columnCenter();

        .text-button {
          color: #999999;
          font-size: 14px;
          font-weight: 400;
        }
      }
    }
  }
}

.priceclass {
  color: #ff7a00;
}
</style>
